const chartSight2Labels = {
    "fr": [
         ["CONTRIBUTIONS", "AU TRAVAIL",],
         ["RELATION AUX", "COLLÈGUES",],
         ["RELATION À", "LA CARRIÈRE",],
         ["RELATION AU", "MARCHÉ DU TRAVAIL",],
         ["LEADERSHIP",],
         ["ENGAGEMENT",],
         ["MANAGEMENT",],
         ["COMMERCIAL",],
         ["COLLABORER ET", "CONTRIBUER",],
         ["ORGANISER ET", "CONTRÔLER",],
         ["ORIENTER ET", "PROPULSER",],
         ["DÉPASSER LE", "CADRE",],
         ["PRENDRE DES", "RISQUES",],
         ["ÉVALUER JUSTEMENT", "SES COMPÉTENCES",],
         ["CONFRONTATION", "À LA TÂCHE",],
         ["CENTRATION SUR", "L’ÉMOTION",],
         ["CENTRATION SUR", "SOUTIEN SOCIAL"]
    ],
    "en": [
         ["CONTRIBUTIONS", "AU TRAVAIL",],
         ["RELATION AUX", "COLLÈGUES",],
         ["RELATION À", "LA CARRIÈRE",],
         ["RELATION AU", "MARCHÉ DU TRAVAIL",],
         ["LEADERSHIP",],
         ["ENGAGEMENT",],
         ["MANAGEMENT",],
         ["COMMERCIAL",],
         ["COLLABORER ET", "CONTRIBUER",],
         ["ORGANISER ET", "CONTRÔLER",],
         ["ORIENTER ET", "PROPULSER",],
         ["DÉPASSER LE", "CADRE",],
         ["PRENDRE DES", "RISQUES",],
         ["ÉVALUER JUSTEMENT", "SES COMPÉTENCES",],
         ["CONFRONTATION", "À LA TÂCHE",],
         ["CENTRATION SUR", "L’ÉMOTION",],
         ["CENTRATION SUR", "SOUTIEN SOCIAL"]
    ]
}

export default chartSight2Labels

















